import React from 'react';
import { Pie } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { useSettingContextInComponent, useSettingsContext } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const CostiAnalisiPieSet = ({ dataProviderName, filters: defaultFilters }) => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const createSliceFilterHandler = (field, addFilter) => (params) => {
        addFilter(field, params);
    };

    return (drawable &&
        <Box className="report-itemgroup">
            <Box className="report-itemrow">
                <Box className="report-item">
                    <Pie
                        title={t("Costs by Area")}
                        dataProviderName={"statisticsviews/costsperarea/aggregatedsumfinancial/views_advertisings_advertisingcost/_related_area_name/value"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_area_name', addFilter)}
                        format='currency'
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Costs by Shop")}
                        dataProviderName={"statisticsviews/costspershop/aggregatedsumfinancial/views_advertisings_advertisingcost/_related_shop_name/value"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_shop_name', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Costs by Agent")}
                        dataProviderName={"statisticsviews/costsperagent/aggregatedsumfinancial/views_advertisings_advertisingcost/_related_agent_fullname/value"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_agent_fullname', addFilter)}
                    />
                </Box>
            </Box>
            <Box className="report-itemrow">
                <Box className="report-item">
                    <Pie
                        title={t("Costs by Source")}
                        dataProviderName={"statisticsviews/costspersource/aggregatedsumfinancial/views_advertisings_advertisingcost/_related_source_name/value"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_source_name', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Costs by Status")}
                        dataProviderName={"statisticsviews/costspersource/aggregatedsumfinancial/views_advertisings_advertisingcost/status/value"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('status', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Costs by Product")}
                        dataProviderName={"statisticsviews/costspersource/aggregatedsumfinancial/views_advertisings_advertisingcost/product/value"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('product', addFilter)}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default CostiAnalisiPieSet;
